import BaseService from "./BaseService";

export default class ChargeBackService extends BaseService {
    public static getChargeBackDetails(token: string, postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'dashboard/chargeback/list', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
            body: JSON.stringify(postData)
        })
    }

    public static getFile(token: string, persona_inq_id: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}profile/get/persona-info/pdf-print/${persona_inq_id}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        })
    }

    public static sendEmail(token: string, reference_Number: string) {
        return BaseService.sendRequest(`${process.env.REACT_APP_API_URL}dashboard/chargeback/send/email/${reference_Number}`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': "Bearer " + token
            },
        })
    }
}